"use server"

import { listProducts } from "@lib/data/products"

export type StorefrontSearchResult = {
  id: string
  title: string
  handle: string
  thumbnail: string | null
}

export async function searchProducts(query: string): Promise<StorefrontSearchResult[]> {
  const q = query.trim()
  if (q.length < 2) return []

  const { response } = await listProducts({
    countryCode: "tr",
    queryParams: { q, limit: 6 },
  })

  return response.products.map((product) => ({
    id: product.id,
    title: product.title,
    handle: product.handle,
    thumbnail: product.thumbnail ?? null,
  }))
}
